<template>
    <Modal ref="modal" class="sort-categories-modal" @opened="onOpenModal" @closed="onCloseModal">
        <template #button="sp">
            <slot name="button" :show-modal="sp.showModal"></slot>
        </template>
        <template #header>
            <div class="h3">Ordre des catégories</div>
        </template>
        <template #body="sp">
            <div v-if="loading">
                <i class="fad fa-spin fa-spinner"></i> Chargement...
            </div>
            <ErrorsZone v-else-if="loadErrors" :errors="loadErrors" class="my-2" />
            <div v-else>
                <NestedDraggable :list="categories" />

                <ErrorsZone v-if="sendErrors" :errors="sendErrors" class="my-2" />

                <div class="d-flex justify-content-end justify-content-between">
                    <button type="button" class="btn btn-secondary" @click="closeModal()">
                        <i class="fad fa-backspace"></i> Fermer
                    </button>
                    <button type="button" class="btn btn-outline-success" @click="submit()" :disabled="sending">
                        <template v-if="sending"><i class="fad fa-spin fa-spinner"></i> Enregistrement en cours</template>
                        <template v-else><i class="fad fa-save"></i> Enregistrer</template>
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import ErrorsZone from "../ErrorsZone";
import Modal from "../Modal";
import NestedDraggable from "../NestedDraggable"
import {usePostRequest} from "../compositions/axios/postRequest";
import {useGetLoader} from "../compositions/axios/loadingRequest"

export default {
    name: 'SortCategoriesModal',

    components: {
        NestedDraggable,
        Modal,
        ErrorsZone,
    },

    setup(props) {
        const {
            loading: sending,
            errors: sendErrors,
            post: send,
        } = usePostRequest();

        const {
            loading,
            errors: loadErrors,
            load,
        } = useGetLoader();

        return {
            loading,
            loadErrors,
            load,

            sending,
            sendErrors,
            send,
        };
    },

    data() {
        return {
            categories: [],
        }
    },

    methods: {
        async submit() {
            let response = await this.send('/espace-admin/categories/ordre', {
                categories: this.categories,
            });

            if (response && response.success) {
                window.location.reload();
                this.closeModal();
            }
        },

        showModal() {
            this.$refs.modal.showModal();
        },

        closeModal() {
            this.$refs.modal.closeModal();
        },

        async onOpenModal() {
            this.categories = [];

            const response = await this.load('/espace-admin/categories/ordre');

            if (response) {
                this.categories = response;
            }
        },

        onCloseModal() {
            this.categories = [];

            this.$emit('closed');
        },
    },
}
</script>

<style lang="scss">
.sort-categories-modal {
    .modal-container {
        max-width: 900px;
        width: auto;
    }
}
</style>
